import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

export const REGISTER_NOTIFICATION = '/v2/notification/registration';
export const registFirebaseToken = (registerFirebaseToken: any) => {
  return httpClient.put<any>(REGISTER_NOTIFICATION, {
    ...registerFirebaseToken,
  });
};
export const useRegistFirebaseToken = (
  params?: UseMutationOptions<AxiosResponse<any>, AxiosError<any>, any>,
) => {
  return useMutation<AxiosResponse<any>, AxiosError<any>, any>(
    registFirebaseToken,
    params,
  );
};
